import React from "react";
import { Box, Typography } from "@mui/material";
import SouthRoundedIcon from "@mui/icons-material/SouthRounded";
import ChevronRightRoundedIcon from "@mui/icons-material/ChevronRightRounded";

import { brand, fonts } from "../../themes/theme";

/**
 * Secuencia vertical de pasos sin dato cuantificado (p.ej. "Ciclo TRA por
 * dentro"): cada paso es un circulo numerado; las fugas cualitativas van como
 * chip lateral gris, SIN porcentaje (a diferencia de FunnelChart, que si lo
 * tiene). El ultimo paso puede ser clicable (drill a otro nivel).
 *
 * @param {Array} steps - { label, leak?, clickable?, onClick? }
 */
function JourneyStepper({ steps }) {
    return (
        <Box sx={{ height: "100%", display: "flex", flexDirection: "column", justifyContent: "space-between" }}>
            {steps.map((step, i) => (
                <Box key={i} sx={{ display: "flex", flexDirection: "column" }}>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1.5 }}>
                        <Box
                            sx={{
                                flexShrink: 0,
                                width: 26,
                                height: 26,
                                borderRadius: "50%",
                                border: `2px solid ${brand.primary}`,
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontSize: 12.5,
                                color: "primary.main",
                            }}
                        >
                            {i + 1}
                        </Box>
                        <Box
                            component={step.clickable ? "button" : "div"}
                            type={step.clickable ? "button" : undefined}
                            onClick={step.clickable ? step.onClick : undefined}
                            sx={{
                                border: 0,
                                bgcolor: "transparent",
                                p: 0,
                                display: "flex",
                                alignItems: "center",
                                gap: 0.5,
                                cursor: step.clickable ? "pointer" : "default",
                                "&:hover": step.clickable ? { color: "primary.main" } : undefined,
                            }}
                        >
                            <Typography
                                sx={{
                                    fontFamily: fonts.body,
                                    fontSize: 14,
                                    fontWeight: 500,
                                    color: "text.primary",
                                }}
                            >
                                {step.label}
                            </Typography>
                            {step.clickable && (
                                <>
                                    <ChevronRightRoundedIcon sx={{ fontSize: 16, color: "primary.main" }} />
                                    <Typography sx={{ fontSize: 12, color: "primary.main" }}>{step.continueHint}</Typography>
                                </>
                            )}
                        </Box>
                    </Box>

                    {step.leak && (
                        <Box sx={{ display: "flex", alignItems: "center", gap: 0.75, pl: "12px", py: 0.5 }}>
                            <SouthRoundedIcon sx={{ fontSize: 12, color: "text.secondary", transform: "rotate(-40deg)" }} />
                            <Typography sx={{ fontSize: 12, color: "text.secondary", lineHeight: 1.35 }}>
                                {step.leak}
                            </Typography>
                        </Box>
                    )}

                    {i < steps.length - 1 && (
                        <Box sx={{ width: 2, height: 14, bgcolor: brand.gray200, ml: "12px" }} />
                    )}
                </Box>
            ))}
        </Box>
    );
}

export default JourneyStepper;
